import { createContext, useContext, type ReactNode } from "react";
import type { MapProvider } from "./index.js";

/**
 * E-BUNDLE-25 — Provider-Wirt der Karten, getrennt von `<MapView>`.
 *
 * Die App haengt `MapsSetupProvider` in `main.tsx` um den ganzen
 * Baum, also liegt alles, was dort statisch importiert wird, im
 * Entry-Chunk. Solange Wirt und Ansicht in derselben Datei standen,
 * zog dieser eine Import auch `<MapView>` samt aller Mount-,
 * Marker-, Polylinien-, Kamera- und Farbschema-Effekte in den
 * Startpfad, obwohl die Landeroute /dashboard gar keine Karte hat.
 *
 * Hier bleibt nur der Kontext: ein Provider-Wert hoch, ein Hook
 * herunter. `<MapView>` wohnt weiter in `react.tsx` und wird
 * ausschliesslich von den lazy geladenen Kartenseiten gezogen.
 */
const ProviderContext = createContext<MapProvider | null>(null);

export interface MapsProviderHostProps {
  provider: MapProvider;
  children: ReactNode;
}

export function MapsProviderHost({ provider, children }: MapsProviderHostProps) {
  return <ProviderContext.Provider value={provider}>{children}</ProviderContext.Provider>;
}

export function useMapsProvider(): MapProvider {
  const ctx = useContext(ProviderContext);
  if (!ctx) throw new Error("useMapsProvider must be used inside <MapsProviderHost>");
  return ctx;
}
